import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import * as React from 'react';

import { contactEmail, contactEmailIsSet } from './data';
import usePageMeta from './usePageMeta';

interface ChannelProps {
  icon: React.ReactNode;
  href?: string;
  label: string;
  note: string;
  external?: boolean;
}

function Channel(props: ChannelProps) {
  const { icon, href, label, note, external } = props;

  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', paddingBottom: 3 }}>
      <Box sx={{ color: '#666', paddingRight: 2, display: 'flex', paddingTop: '2px' }}>{icon}</Box>
      <Box>
        <Typography variant="body1">
          {href ? (
            <Link
              href={href}
              color="inherit"
              underline="hover"
              target={external ? '_blank' : undefined}
              rel={external ? 'noopener' : undefined}
            >
              {label}
            </Link>
          ) : (
            <span>{label}</span>
          )}
        </Typography>
        <Typography variant="body2" sx={{ color: '#666' }}>
          {note}
        </Typography>
      </Box>
    </Box>
  );
}

export default function ContactPage() {
  usePageMeta(
    'Contact',
    'Contact the Berlin studio of Yoav Reches for press enquiries, commissions, exhibitions and available works.',
    'contact',
  );

  return (
    <Container id="contact" maxWidth={'md'}>
      <Typography variant="h5" paddingTop={2} paddingBottom={1}>
        Contact
      </Typography>
      <Typography paragraph variant="body2" sx={{ color: '#666', paddingBottom: 4 }}>
        Enquiries about available works, commissions, exhibitions and
        press are welcome.
      </Typography>

      {contactEmailIsSet && (
        <Channel
          icon={<MailOutlineIcon fontSize="small" />}
          label={contactEmail}
          note="Press, galleries, commissions and available works"
        />
      )}

      <Channel
        icon={<InstagramIcon fontSize="small" />}
        href="https://www.instagram.com/yoav.reches/"
        label="@yoav.reches"
        note="Work in progress from the studio"
        external
      />

      <Channel
        icon={<LinkedInIcon fontSize="small" />}
        href="https://www.linkedin.com/in/yoav-reches-4016432b/"
        label="LinkedIn"
        note="Professional background and product design work"
        external
      />

      <Box paddingTop={4}>
        <Typography variant="body2" sx={{ color: '#666' }}>
          For editorial requests, high-resolution images with captions and photographer credits are
          available on request.
        </Typography>
      </Box>
    </Container>
  );
}
